import UniformModel from '../models/UniformModel';
export default {
    model: UniformModel,
    timeout: 10,
    expires: 300,
    pathTemplate: 'api/v1/uniforms/game?gamePks={gamePk}'
};
